"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternetStatusContext = void 0;
const react_1 = require("react");
exports.InternetStatusContext = (0, react_1.createContext)({});
